import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ChangeDetectorRef, Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { ProductCategorySummaryService } from './product-category-summary.service';
import { ExceptionHelper } from './../../../../helper';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
    selector: 'app-product-category-summary',
    templateUrl: './product-category-summary.component.html'
})

@Injectable()
export class ProductCategorySummaryComponent implements AfterViewInit, OnInit {
  applied: Boolean = true;
  activateCheckboxStatus: number;

  dataTable: any;
  productCats: any[];
  res: Observable<any>;

  constructor(
    private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private http: HttpClient,
    private router: Router,
    private productCatSummaryService: ProductCategorySummaryService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('en-us');
  }

  ngAfterViewInit() {
    this.getSummary();
  }

  ngOnInit() { }

  apply() {
    this.getSummary();
  }

  checkboxStatus(input) {
    this.applied = input.isApply;
    this.activateCheckboxStatus = input.activateCheckboxStatus;
  }

  getSummary() {
    this.productCatSummaryService.getSummary(this.activateCheckboxStatus)
      .subscribe((data: any) => {
        this.applied = true;
        if ($.fn.dataTable.isDataTable('#productCatDataTables')) { $('#productCatDataTables').DataTable().destroy(); }

        this.productCats = data.productCatListModel;

        this.chRef.detectChanges();

        const table: any = $('#productCatDataTables');
        this.dataTable = table.DataTable();
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
      });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/summary/product-category-summary.component.ts